module.exports = __webpack_public_path__ + "img/Pattern01.221c42d6.png";